import { TimesheetsState } from '@/store/timesheets/types';

const state: TimesheetsState = {
  timesheets: [],
  conditions: undefined,
  pager: {
    current: 1,
    last: 1,
    totalLength: 0,
  },
  sortBy: undefined,
  WorkSummaryDiffs: [],
  yearlyworkdays: [],
};

export default state;
